var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInteliconvoAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1556_28)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 256C512 206.933 509.867 162.133 501.333 136.533C492.8 106.667 482.133 78.9333 456.533 53.3333C424.533 23.4667 396.8 14.9333 354.133 6.4C324.267 2.13333 288 0 266.667 0C260.267 0 253.867 0 247.467 0C224 0 189.867 2.13333 157.867 6.4C115.2 14.9333 85.3333 25.6 55.4667 53.3333C27.7333 78.9333 19.2 106.667 10.6667 136.533C2.13333 162.133 0 206.933 0 256C0 305.067 2.13333 349.867 10.6667 375.467C19.2 405.333 29.8667 433.067 55.4667 458.667C87.4667 488.533 115.2 497.067 157.867 505.6C192 512 234.667 512 256 512C277.333 512 320 512 356.267 505.6C396.8 497.067 426.667 488.533 458.667 458.667C484.267 435.2 494.933 407.467 503.467 375.467C509.867 349.867 512 305.067 512 256Z",
    fill: "url(#paint0_linear_1556_28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.333 181.333H179.2V332.8H149.333V181.333ZM89.5996 226.133H119.466V285.867H89.5996V226.133ZM211.2 104.533H241.066V375.467H211.2V104.533ZM270.933 134.4H300.8V405.333H270.933V134.4ZM330.666 181.333H362.666V332.8H332.8V181.333H330.666ZM392.533 226.133H422.4V285.867H392.533V226.133Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1556_28",
    x1: 256,
    y1: 0,
    x2: 256,
    y2: 512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#018CC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#442A79"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1556_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteliconvoAi);
export default __webpack_public_path__ + "static/media/InteliconvoAi.c5adcb67cd921e7811c2ae74d7766b54.svg";
export { ForwardRef as ReactComponent };